import config       from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

const BASE = `${config.API_URL}RadioDesignUserPrivileges`;

// Returns all users from AspNetUsers (for the user picker dropdown)
export const GetAspNetUsers = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/users` });

// Returns all active modules
export const GetModules = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/modules` });

// Returns all active vendors (dbo.TrackerVendor, IsActive = 1)
export const GetVendors = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/vendors` });

// Returns all configured user privileges
export const GetAllPrivileges = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}` });

// Returns the privilege for a specific user
export const GetPrivilegeByUserId = (userId) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/${userId}` });

// Assigns a new privilege to an existing AspNetUser
// payload: { userId, role, vendor, moduleAccess: [{ moduleId, hasAccess }] }
export const CreatePrivilege = (payload) =>
	AxiosRequest({ method: 'POST', url: `${BASE}`, data: payload });

// Updates role, vendor and module access for a user
// payload: { role, vendor, moduleAccess: [{ moduleId, hasAccess }] }
export const UpdatePrivilege = (userId, payload) =>
	AxiosRequest({ method: 'PUT', url: `${BASE}/${userId}`, data: payload });

// Removes all privileges for a user
export const DeletePrivilege = (userId) =>
	AxiosRequest({ method: 'DELETE', url: `${BASE}/${userId}` });